<template>
  <b-modal :active.sync="isDoDModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Update Date of Delivering Final Dataset
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Delivering Final Dataset">
              <b-datepicker
                name="date_of_delivering_final_dataset"
                required
                v-model="date_of_delivering_final_dataset"
                :date-formatter="dateFormatter"
                icon="calendar-today"
                trap-focus
                data-cy="delivering-final-dataset"
              >
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
        >
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
import router from "../../router/index";

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    checkedRows: {
      type: Array,
      default: null
    },
    filters: {
      type: String,
      default: null
    },
    checkedAll: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      date_of_delivering_final_dataset: null,
      isDoDModalActive: false,
      reportingTrackerService: new ReportingTrackerDataService()
    };
  },
  methods: {
    handleApiError(reason) {
      console.log(reason.response.data);
    },
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    submit() {
      try {
        this.reportingTrackerService
          .deliveringFinalDatasetDeadline(
            this.checkedRows.map(records => records.id),
            this.date_of_delivering_final_dataset,
            this.filters,
            this.checkedAll
          )
          .subscribe(response => {
            if (response["success"]) {
              this.$emit(
                "confirm",
                this.dateFormatter(this.date_of_delivering_final_dataset)
              );

              this.date_of_delivering_final_dataset = null;
              this.$buefy.dialog.alert({
                title: "Success",
                message: response["success"],
                onConfirm: () => this.$router.go()
              });
            } else if (response["error"]) {
              this.$buefy.dialog.alert({
                title: "Error",
                message: response["error"]
              });
              return false;
            }
          }, this.handleApiError);
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Nothing to Update!",
          message: e.message
        });
      }
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isDoDModalActive = newValue;
    },
    isDoDModalActive(newValue) {
      if (!newValue) {
        this.$emit("cancel");
      }
    }
  }
};
</script>
